<template>
    <div class="overflow-x-hidden">
        <header-panel />

        <div class="px-2">
            <section class="container mx-auto bg-white rounded-lg shadow-light dark:shadow-dark dark:bg-dark.bkg dark:text-dark.contentText p-5 sm:p-10 mt-24">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                    <!-- Left side: Text content -->
                    <div>
                        <h1 class="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
                            {{ $t('affiliate_heading') }}
                        </h1>
                        <p class="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
                            {{ $t('affiliate_description') }}
                        </p>
                        <a 
                            href="http://cc.payproglobal.com/AffiliateSignup/8DD3EAC05654668" 
                            target="_blank" 
                            class="inline-block bg-growth text-white font-semibold py-3 px-6 rounded-lg hover:bg-growth/90 transition-colors duration-200"
                        >
                            {{ $t('become_affiliate') }}
                        </a>
                    </div>
                    
                    <!-- Right side: Space for image -->
                    <div class="flex justify-center items-center">
                        <div class="w-full max-w-md h-64 md:h-80 rounded-lg flex items-center justify-center">
                            <!-- Placeholder for your Undraw image -->
                            <img src="@/assets/images/undraw_invest_t695.svg" alt="Affiliate" />
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <footer-panel />
    </div>
</template>

<script setup>
    import headerPanel from "@/components/landing/HeaderLanding.vue";
    import FooterPanel from "@/components/landing/FooterLanding.vue";
</script>

<script>
    export default {
        components: {FooterPanel, headerPanel},
        data() {
            return {
                menuOpen:false,
            }
        },
    }
</script>